/**
 * WhatsApp Business display name as configured in askng.it (Settings → Channels).
 * Update this before sending the authorization URL to askng.it / Meta.
 */
export const WHATSAPP_DISPLAY_NAME = "Beatenberg Resort & Spa";

export const WHATSAPP_AUTHORIZATION_LAST_UPDATED = "19 May 2026";
